// extracted by mini-css-extract-plugin
export default {"layout_test":"index_layout_test_ilFtO"};